import React from 'react';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import { Page } from './common/styles';
import Header from './common/header';
import SiteMap from './common/site-map';
import Footer from './common/footer';
import Content from './legal-elements/content';
import Contact from './common/contact';

export default function Legal(props) {
  const common = commonProps();
  const state = {
    ...props,
    ...common,
    light: true,
  };

  return (
    <ThemeProvider theme={state}>
      <Page>
        <Header />
        <Content />
        <Contact formId="contact_us" formName="contact_us" formTitle="Contact Us" />
        <SiteMap />
        <Footer />
      </Page>
    </ThemeProvider>
  );
}
